export default {
    slug: 'conventional-braces',
    img: '/img/tr-braces.jpg',
    icon: 'braces',
    en: {
        name: 'Conventional Braces',
        short: 'Proven orthodontic alignment for teenagers and adults.',
        metaTitle: 'Conventional Braces in Johor Bahru | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Conventional braces in Johor Bahru for teenagers and young adults. Honest assessment, clear explanations and transparent fees at Klinik Pergigian Irma Ariandi.',
        kicker: 'Orthodontics',
        heroTitle: 'A proven way to straighten teeth — planned carefully, explained honestly.',
        heroSub: 'Conventional braces remain the most widely used orthodontic treatment for teenagers and adults. Here is how we assess, plan and support braces treatment at our Johor Bahru clinic.',
        whoIntro: 'Braces may be considered for:',
        who: [
            'Teenagers with crowded, overlapping or spaced teeth',
            'Patients with a noticeable bite difference',
            'Young adults who want a fixed treatment they do not need to manage daily',
            'Parents seeking a clinic that explains the process to the whole family',
        ],
        problem: 'Braces move teeth gradually into a better position using brackets, wires and controlled force. They address crowding, spacing and certain bite differences. Whether braces are the right choice — and when to start — is an individual clinical decision made after assessment.',
        assessmentIntro: 'At a first orthodontic assessment you can expect:',
        assessment: [
            'A full examination of teeth, bite and oral health',
            'Records or x-rays where clinically needed',
            'A plain-language explanation of what we see',
            'A discussion of the options — braces, clear aligners, or monitoring first',
            'Fees explained in writing before you decide anything',
        ],
        optionsIntro: 'The choices we discuss at assessment:',
        options: [
            { name: 'Conventional braces', text: 'Fixed brackets and wires — the option most teenagers and parents choose, because it does not depend on daily discipline the way removable appliances do.' },
            { name: 'Clear aligners (where suitable)', text: 'For some teenagers, clear aligners may also be considered. Suitability depends on the type of problem and daily wear responsibility — see our clear aligners page.' },
            { name: 'Monitoring first', text: 'In some cases the honest recommendation is to wait and monitor development. An early assessment does not always mean early treatment.' },
        ],
        knowIntro: 'What patients should know:',
        know: [
            'Treatment duration varies by individual — your doctor will give an estimate after assessment, not before',
            'Braces need care: brushing around brackets matters, and we will show you how',
            'Adjustment visits are a regular part of treatment — plan the rhythm with the clinic',
            'Fees are explained in writing before treatment starts, including what follow-up covers',
        ],
        followup: 'Adjustment visits are part of treatment, and retention keeps the result in place afterwards. If a bracket breaks or a wire irritates, contact the clinic — practical help is part of the plan.',
        faqs: [
            { q: 'What age is suitable for braces?', a: 'It depends on the teeth and jaw development. Many families begin orthodontic assessment in the mixed-dentition years, with active treatment often starting in the teenage years — but the right timing for your child is a clinical decision, not a date.' },
            { q: 'Braces or clear aligners for my teenager?', a: 'Both can work; it depends on the type of problem and your teen\u2019s readiness to wear and care for removable aligners. We explain both honestly at assessment.' },
            { q: 'What if a bracket breaks during school?', a: 'Contact the clinic. You will get practical guidance on the phone and, if needed, a repair visit. Breaks are part of real orthodontic life.' },
            { q: 'How are fees structured?', a: 'Transparently. You receive an explanation and a written breakdown before treatment begins — nothing is decided after the fact.' },
        ],
        teenNote: 'Most braces patients are teenagers, and most of our first conversations are with parents. Visit the Teen Smile parents\u2019 guide for what the first assessment is like and what to ask.',
    },
    ms: {
        name: 'Braces Biasa',
        short: 'Ortodontik yang terbukti untuk remaja dan dewasa.',
        metaTitle: 'Braces Biasa di Johor Bahru | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Braces biasa di Johor Bahru untuk remaja dan dewasa muda. Penilaian jujur, penjelasan jelas dan yuran telus di Klinik Pergigian Irma Ariandi.',
        kicker: 'Ortodontik',
        heroTitle: 'Cara yang terbukti untuk meluruskan gigi — dirancang teliti, dijelaskan jujur.',
        heroSub: 'Braces biasa kekal sebagai rawatan ortodontik yang paling banyak digunakan untuk remaja dan dewasa. Ini bagaimana kami menilai, merancang dan menyokong rawatan braces di klinik kami di Johor Bahru.',
        whoIntro: 'Braces mungkin dipertimbangkan untuk:',
        who: [
            'Remaja dengan gigi yang bertindih atau berjarak',
            'Pesakit dengan perbezaan gigitan yang ketara',
            'Dewasa muda yang mahukan rawatan tetap yang tidak perlu diurus setiap hari',
            'Ibu bapa yang mencari klinik yang menerangkan proses kepada seluruh keluarga',
        ],
        problem: 'Braces menggerakkan gigi secara beransur-ansur ke kedudukan yang lebih baik menggunakan bracket, wayar dan daya yang terkawal. Ia menangani gigi bertindih, berjarak dan perbezaan gigitan tertentu. Sama ada braces sesuai — dan bila memulakan — ialah keputusan klinikal individu selepas penilaian.',
        assessmentIntro: 'Pada penilaian ortodontik pertama, anda boleh jangkakan:',
        assessment: [
            'Pemeriksaan penuh gigi, gigitan dan kesihatan mulut',
            'Rekod atau x-ray di mana perlu secara klinikal',
            'Penjelasan dalam bahasa mudah tentang apa yang kami nampak',
            'Perbincangan pilihan — braces, clear aligners, atau pemantauan dahulu',
            'Yuran diterangkan secara bertulis sebelum anda membuat keputusan',
        ],
        optionsIntro: 'Pilihan yang kami bincangkan pada penilaian:',
        options: [
            { name: 'Braces biasa', text: 'Bracket dan wayar tetap — pilihan yang paling kerap dipilih remaja dan ibu bapa, kerana ia tidak bergantung pada disiplin harian seperti alat yang boleh dibuka.' },
            { name: 'Clear aligners (jika sesuai)', text: 'Untuk sebilangan remaja, clear aligners juga boleh dipertimbangkan. Kesesuaian bergantung pada jenis masalah dan tanggungjawab pemakaian harian — lihat halaman clear aligners kami.' },
            { name: 'Pemantauan dahulu', text: 'Dalam sesetengah kes, cadangan yang jujur ialah menunggu dan memantau perkembangan. Penilaian awal tidak selalunya bermakna rawatan awal.' },
        ],
        knowIntro: 'Apa yang pesakit patut tahu:',
        know: [
            'Tempoh rawatan berbeza mengikut individu — doktor akan beri anggaran selepas penilaian, bukan sebelum',
            'Braces memerlukan penjagaan: memberus sekeliling bracket penting, dan kami akan tunjukkan caranya',
            'Lawatan pelarasan adalah sebahagian rawatan — rancangkan rentaknya bersama klinik',
            'Yuran diterangkan secara bertulis sebelum rawatan bermula, termasuk apa yang diliputi susulan',
        ],
        followup: 'Lawatan pelarasan adalah sebahagian daripada rawatan, dan retensi mengekalkan hasil selepasnya. Jika bracket patah atau wayar menggatal, hubungi klinik — bantuan praktikal adalah sebahagian daripada pelan.',
        faqs: [
            { q: 'Umur berapa sesuai untuk braces?', a: 'Ia bergantung pada gigi dan perkembangan rahang. Ramai keluarga memulakan penilaian ortodontik pada tahun pergantian gigi, dengan rawatan aktif kerap bermula pada usia remaja — tetapi masa yang sesuai untuk anak anda ialah keputusan klinikal, bukan tarikh.' },
            { q: 'Braces atau clear aligners untuk remaja saya?', a: 'Kedua-duanya boleh berkesan; ia bergantung pada jenis masalah dan kesediaan anak mengurus aligner yang boleh dibuka. Kami terangkan kedua-duanya dengan jujur pada penilaian.' },
            { q: 'Macam mana jika bracket patah semasa sekolah?', a: 'Hubungi klinik. Anda akan dapat panduan praktikal melalui telefon dan, jika perlu, lawatan pembaikan. Bracket patah adalah sebahagian daripada kehidupan ortodontik yang sebenar.' },
            { q: 'Bagaimana yuran disusun?', a: 'Dengan telus. Anda akan menerima penjelasan dan rincian bertulis sebelum rawatan bermula — tiada apa yang diputuskan selepas itu.' },
        ],
        teenNote: 'Kebanyakan pesakit braces ialah remaja, dan kebanyakan perbualan pertama kami adalah dengan ibu bapa. Lawati panduan ibu bapa Teen Smile untuk tahu bagaimana penilaian pertama berlangsung dan apa yang patut ditanya.',
    },
    zh: {
        name: '传统牙套',
        short: '为青少年与成人提供的成熟正畸治疗。',
        metaTitle: '新山传统牙套（Braces）| Irma Ariandi 牙科诊所',
        metaDesc: '新山为青少年与年轻成人提供的传统牙套治疗。诚实评估、清楚解释、收费透明。',
        kicker: '正畸治疗',
        heroTitle: '经时间验证的矫正方式 —— 细心规划，诚实解释。',
        heroSub: '传统牙套仍是青少年与成人最常用的正畸治疗。这里是我们在新山诊所如何评估、规划与支持牙套治疗。',
        whoIntro: '可能考虑牙套的情况：',
        who: [
            '牙齿拥挤、重叠或有缝隙的青少年',
            '咬合差异明显的患者',
            '希望使用固定式、无需每天自行管理治疗的年轻成人',
            '希望诊所向全家解释清楚的家长',
        ],
        problem: '牙套通过托槽、弓丝和受控的力量，逐步把牙齿移动到更好的位置，处理拥挤、缝隙与部分咬合问题。牙套是否适合、何时开始 —— 需要评估后的个体化临床判断。',
        assessmentIntro: '第一次正畸评估包括：',
        assessment: [
            '对牙齿、咬合与口腔健康的全面检查',
            '临床需要时拍摄记录或X光',
            '用简单语言解释我们看到的情况',
            '讨论选项 —— 牙套、隐形牙套、或先观察',
            '在您做任何决定之前，书面解释收费',
        ],
        optionsIntro: '评估时讨论的选择：',
        options: [
            { name: '传统牙套', text: '固定托槽与弓丝 —— 大多数青少年与家长的选择，因为它不像可摘式矫治器那样依赖每日自律。' },
            { name: '隐形牙套（如适合）', text: '部分青少年也可以考虑隐形牙套。是否适合取决于问题类型与每日佩戴的责任心 —— 请参阅我们的隐形牙套页面。' },
            { name: '先观察', text: '在某些情况下，诚实的建议是等待并观察发育。早期评估并不一定意味着立即治疗。' },
        ],
        knowIntro: '患者须知：',
        know: [
            '治疗时长因人而异 —— 医生在评估后才会给出预估',
            '牙套需要护理：清洁托槽周围很重要，我们会教您方法',
            '定期复诊调整是治疗的一部分 —— 与诊所一起安排节奏',
            '费用在治疗前书面说明，包括复诊涵盖的内容',
        ],
        followup: '调整复诊是治疗的一部分，之后保持器帮助维持结果。如果托槽脱落或弓丝刮嘴，请联系诊所。',
        faqs: [
            { q: '几岁适合开始牙套？', a: '取决于牙齿与颌骨发育。许多家庭在换牙期开始评估，治疗常在青少年期进行 —— 但确切时机是临床判断，不是固定年龄。' },
            { q: '我的孩子该选传统牙套还是隐形牙套？', a: '两者都可能有效，取决于问题类型与孩子佩戴管理隐形牙套的自觉性。评估时我们会诚实地解释两者。' },
            { q: '托槽在学校脱落怎么办？', a: '联系诊所即可。我们会先电话指导，需要时安排修复。托槽脱落是正畸生活中的常态。' },
            { q: '费用如何安排？', a: '透明为上。治疗前会有书面明细 —— 绝不事后加价。' },
        ],
        teenNote: '大部分牙套患者是青少年，而我们的第一次对话多是与家长。请阅读 Teen Smile 家长指南，了解第一次评估的内容与该问什么。',
    },
    ta: {
        name: 'பிரேசஸ்',
        short: 'பதின்ம வயதினர் மற்றும் பெரியவர்களுக்கான நம்பகமான பற்கள் நேர்த்தி.',
        metaTitle: 'ஜொகூர் பாருவில் பிரேசஸ் | இர்மா அரியாண்டி பல் கிளினிக்',
        metaDesc: 'ஜொகூர் பாருவில் பதின்ம வயதினருக்கான பிரேசஸ். நேர்மையான மதிப்பீடு, தெளிவான விளக்கம், வெளிப்படையான கட்டணம்.',
        kicker: 'பற்கள் நேர்த்தி',
        heroTitle: 'பற்களை நேராக்கும் நம்பகமான வழி — கவனமாகத் திட்டமிட்டு, நேர்மையாக விளக்குகிறோம்.',
        heroSub: 'பதின்ம வயதினர் மற்றும் பெரியவர்களுக்கு பிரேசஸ் தான் மிகப் பரவலாகப் பயன்படுத்தப்படும் சிகிச்சை. ஜொகூர் பாரு கிளினிக்கில் நாங்கள் எவ்வாறு மதிப்பிடுகிறோம், திட்டமிடுகிறோம்.',
        whoIntro: 'பிரேசஸ் கருத்தில் கொள்ளக்கூடியவர்கள்:',
        who: [
            'பற்கள் அடுக்கியோ இடைவெளியுடனோ உள்ள பதின்ம வயதினர்',
            'கடித்தல் வேறுபாடு தெளிவாக உள்ளோர்',
            'தினசரி பராமரிப்பு தேவையற்ற நிலையான சிகிச்சை விரும்புவோர்',
            'குடும்பத்திற்கே விளக்கும் கிளினிக்கைத் தேடும் பெற்றோர்',
        ],
        problem: 'பிரேசஸ் பிராக்கெட் மற்றும் கம்பிகள் மூலம் பற்களைப் படிப்படியாக நகர்த்தி, நெருக்கடி, இடைவெளி, கடித்தல் வேறுபாடுகளை நிவர்த்தி செய்கிறது. உங்களுக்கு ஏது சரி என்பது மதிப்பீட்டுக்குப் பிறகான மருத்துவ முடிவு.',
        assessmentIntro: 'முதல் மதிப்பீட்டில் எதிர்பார்க்கக்கூடியவை:',
        assessment: [
            'பற்கள், கடித்தல், வாய் ஆரோக்கியம் ஆகியவற்றின் முழுமையான பரிசோதனை',
            'மருத்துவ ரீதியாகத் தேவைப்பட்டால் எக்ஸ்-ரே',
            'நாம் காண்பதை எளிய மொழியில் விளக்குதல்',
            'விருப்பங்கள் பற்றிய உரையாடல் — பிரேசஸ், clear aligners, அல்லது கண்காணிப்பு',
            'முடிவெடுப்பதற்கு முன்பே கட்டணம் எழுத்தில் விளக்கம்',
        ],
        optionsIntro: 'மதிப்பீட்டில் விவாதிக்கும் விருப்பங்கள்:',
        options: [
            { name: 'பிரேசஸ் (நிலையான)', text: 'நிலையான பிராக்கெட் மற்றும் கம்பிகள் — பெரும்பாலான பதின்ம வயதினர் மற்றும் பெற்றோரின் தேர்வு; அகற்றக்கூடிய கருவிகளைப் போல தினசரி ஒழுக்கத்தைச் சாராததால்.' },
            { name: 'Clear aligners (பொருத்தமானால்)', text: 'சில பதின்ம வயதினருக்கு clear aligners-உம் பரிசீலிக்கப்படலாம். பொருத்தம் பிரச்சனை வகை மற்றும் தினசரி அணியும் பொறுப்பைப் பொறுத்தது — எங்கள் clear aligners பக்கத்தைப் பாருங்கள்.' },
            { name: 'முதலில் கண்காணிப்பு', text: 'சில நிலைகளில் நேர்மையான பரிந்துரை காத்திருந்து வளர்ச்சியைக் கண்காணிப்பது. ஆரம்ப மதிப்பீடு எப்போதும் உடனடி சிகிச்சை அல்ல.' },
        ],
        knowIntro: 'நோயாளிகள் அறிந்திருக்க வேண்டியவை:',
        know: [
            'சிகிச்சைக் கால அளவு தனிநபருக்கு வேறுபடும் — மதிப்பீட்டிற்குப் பிறகே மதிப்பீடு',
            'பிராக்கெட்டைச் சுற்றித் துலக்குவது முக்கியம்; நாங்கள் காட்டுவோம்',
            'தவறாமல் சரிசெய்யும் வருகைகள் — கிளினிக்குடன் திட்டமிடுங்கள்',
            'சிகிச்சைக்கு முன்பே கட்டணம் எழுத்தில் விளக்கப்படும்',
        ],
        followup: 'சரிசெய்யும் வருகைகள் சிகிச்சையின் ஒரு பகுதி. பிராக்கெட் உடைந்தால் கிளினிக்கைத் தொடர்பு கொள்ளுங்கள்.',
        faqs: [
            { q: 'எந்த வயதில் பிரேசஸ் தொடங்கலாம்?', a: 'பற்கள் மற்றும் தாடை வளர்ச்சியைப் பொறுத்தது. பல குடும்பங்கள் பல் மாறும் காலத்தில் மதிப்பீடு தொடங்குகிறார்கள் — ஆனால் சரியான நேரம் என்பது மருத்துவ முடிவு.' },
            { q: 'பிரேசஸா, clear aligners-ஆ?', a: 'இரண்டும் வேலை செய்யக்கூடும்; பிரச்சனையின் வகை மற்றும் தினசரி பராமரிப்பைப் பொறுத்தது. மதிப்பீட்டில் இரண்டையும் நேர்மையாக விளக்குவோம்.' },
            { q: 'பள்ளியில் பிராக்கெட் உடைந்தால்?', a: 'கிளினிக்கைத் தொடர்பு கொள்ளுங்கள். தொலைபேசியில் வழிகாட்டல், தேவைப்பட்டால் பழுது வருகை.' },
            { q: 'கட்டணம் எப்படி?', a: 'வெளிப்படையாக. சிகிச்சைக்கு முன்பே எழுத்துப்பூர்வ விளக்கம்.' },
        ],
        teenNote: 'பெரும்பாலான பிரேசஸ் நோயாளிகள் பதின்ம வயதினர்; முதல் உரையாடல்கள் பெற்றோருடன். Teen Smile பெற்றோர் வழிகாட்டியைப் பாருங்கள்.',
    },
};
